module.exports = __webpack_public_path__ + "static/img/img_m.398c5b0f.png";